import { createReducer, on } from '@ngrx/store';

import { cloneDeep, merge } from 'lodash-es';

import * as fromConfigActions from '../actions/config.actions';

export const configFeatureKey = 'config';

export interface State {
  error: string | null;
  googleMapsApiKey: string | null;
  loaded: boolean | null;
  term: {
    description: string | null;
    revisionDate: Date | null;
    version: number | null;
  };
}

export const initialState: State = {
  error: null,
  googleMapsApiKey: null,
  loaded: null,
  term: {
    description: null,
    revisionDate: null,
    version: null
  }
};

export const reducer = createReducer(
  cloneDeep(initialState),
  on(fromConfigActions.loadConfig, (state) =>
    merge({}, state, {
      general: {
        error: null,
        loaded: null
      }
    })
  ),
  on(fromConfigActions.loadConfigSuccess, (state, { payload }) =>
    merge({}, state, {
      googleMapsApiKey: payload.googleMapsApiKey,
      loaded: true,
      term: {
        description: payload.term.description,
        revisionDate: payload.term.revisionDate,
        version: payload.term.version
      }
    })
  ),
  on(fromConfigActions.loadConfigFailure, (state, { payload }) =>
    merge({}, cloneDeep(initialState), {
      error: payload.error,
      loaded: false
    })
  ),
  on(fromConfigActions.loadConfigReset, () => cloneDeep(initialState))
);
